import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { DeeplinkService } from '@rci/self-serve-fido/core/deeplink/deeplink.service';
import { StateService } from '@rci/state-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoutingService } from '@rci/routing-service';
import { LoginService } from '@rci/self-serve-fido/core/fido-login-state/login.service';

const SIGNIN_URL = '/profile/signin';

@Injectable({
  providedIn: 'root',
})
export class RogerBankBlankAppGuard implements CanActivate {
  constructor(
    private readonly deeplinkService: DeeplinkService,
    private readonly loginService: LoginService,
    private readonly routingService: RoutingService,
    private readonly stateService: StateService,
  ) {}

  canActivate(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.stateService.loginState$.pipe(
      map(loginState => {
        const isRelogin = routeSnapshot.queryParamMap.get('relogin');
        if (!!isRelogin) {
          state.url = this.removeParam(state.url, 'relogin');
        }
        if (!loginState.isUserAuthenticated) {
          this.deeplinkService.storeDeeplinkState(state);
          this.routingService.navigate(SIGNIN_URL);
        } else if (!!isRelogin && isRelogin === 'true') {
          this.deeplinkService.storeDeeplinkState(state);
          this.loginService.logOut(true, true);
          return false;
        }
        return loginState.isUserAuthenticated;
      }),
    );
  }

  private removeParam(url, name) {
    const reg = new RegExp(`((&)*${name}=([^&]*))`, 'g');
    return url.replace(reg, '');
  }
}
